import type qs from 'query-string';
import type { UtmParams } from '@app/libs/analytics/events';

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_content', 'utm_campaign'] as const;

export function parseUtmParams(search: qs.ParsedQuery): UtmParams {
  const result: UtmParams = {};

  for (const key of UTM_KEYS) {
    const raw = search[key];
    const value = Array.isArray(raw) ? raw[0] : raw;

    if (typeof value === 'string' && value.length > 0) {
      result[key] = value;
    }
  }

  return result;
}
